import { createFileRoute } from "@tanstack/react-router";

import { EventsHubPage } from "@/components/pages/EventsHubPage";
import { type EventsHubTab, VALID_TABS } from "@/lib/events-hub";

interface EventsHubSearch {
  tab?: EventsHubTab;
}

/**
 * The Events Hub (NAU-341), co-located with the existing event-record detail route
 * so "View" stays in the same family.
 *
 * No FeatureGate: recording a fire drill is a legal requirement available on every
 * plan, so reviewing one must be too — see the note on EventsHubPage.
 */
export const Route = createFileRoute("/_authenticated/event-records/")({
  validateSearch: (search: Record<string, unknown>): EventsHubSearch => ({
    tab: VALID_TABS.includes(search.tab as EventsHubTab)
      ? (search.tab as EventsHubTab)
      : undefined,
  }),
  component: EventsHubPage,
});
